import LoginIcon from './LoginIcon';
export default LoginIcon;